<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <!-- dati generali -->
    <div class="card" [formGroup]="invoiceForm" *ngIf="invoiceForm">
      <div class="card-header">
        <h2 class="card-title">{{ 'INVOICE_GENERAL_INFO' |translate }}</h2>
      </div>
      <div class="card-body row">
        <div class="form-group col-lg-4">
          <label>{{ 'INVOICE_DOCUMENT_TYPE' | translate }}<sup class="text-danger">*</sup></label>
          <ng-select bindLabel="name" bindValue="id" formControlName="invoice_type" [ngClass]="{'is-invalid': fieldHasError('invoice_type')}" [readonly]="!credit_note_types.length" [items]="credit_note_types"
                     [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false">
          </ng-select>
          <div class="invalid-feedback" *ngIf="invoiceForm.controls.invoice_type.errors?.required">{{ "ERRORS.FIELD_IS_REQUIRED" | translate }}</div>
        </div>
        <div class="form-group col-lg-4">
          <label>{{ 'PAYMENT_TERMS' | translate }}<sup class="text-danger">*</sup></label>
          <ng-select bindLabel="name" bindValue="id" formControlName="payment_terms" [ngClass]="{'is-invalid': fieldHasError('payment_terms')}" [readonly]="!payment_terms.length" [items]="payment_terms"
                     [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (change)="handlerChangePaymentTerms()"></ng-select>
          <div class="invalid-feedback" *ngIf="invoiceForm.controls.payment_terms.errors?.required">{{ "ERRORS.FIELD_IS_REQUIRED" | translate }}</div>
        </div>
        <div class="form-group col-lg-4">
          <label>{{ 'DOCUMENT_CODE' | translate }}<sup class="text-danger">*</sup></label>
          <ng-select bindLabel="name" bindValue="id" formControlName="document_code_id" [ngClass]="{'is-invalid':  fieldHasError('document_code_id')}" [readonly]="!document_codes.length" [items]="document_codes"
                     [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false"></ng-select>
          <div class="invalid-feedback" *ngIf="invoiceForm.controls.document_code_id.errors?.required">{{ "ERRORS.FIELD_IS_REQUIRED" | translate }}</div>
        </div>
        <div class="form-group col-lg-4">
          <label for="document_date">{{ 'DOCUMENT_DATE' | translate }}<sup class="text-danger">*</sup></label>
          <app-datepickr id="document_date" [defaultDate]="invoiceForm.value.document_date" [isInvalid]="fieldHasError('document_date')" [displayMonths]="1" (onSelect)="invoiceForm.patchValue({document_date: $event}); handlerChangeDocumentDate();"></app-datepickr>
          <div class="invalid-feedback d-block" *ngIf="showErrors && invoiceForm.controls.document_date.errors?.required">{{ "ERRORS.FIELD_IS_REQUIRED" | translate }}</div>
        </div>
        <div class="form-group col-lg-4">
          <label for="accrual_exercise">{{ 'YEAR_EXERCISE' | translate }}<sup class="text-danger">*</sup></label>
          <input type="number" id="accrual_exercise" [readonly]="!invoiceForm.value.document_date" class="form-control" [ngClass]="{'is-invalid': fieldHasError('accrual_exercise')}" formControlName="accrual_exercise" required>
          <div class="invalid-feedback" *ngIf="invoiceForm.controls.accrual_exercise.errors?.required">{{ "ERRORS.FIELD_IS_REQUIRED" | translate }}</div>
        </div>
        <div class="form-group col-lg-4" id="expiration_date">
          <label>{{ 'EXPIRATION_DATE' | translate }}<sup class="text-danger">*</sup></label>
          <app-datepickr *ngIf="invoiceForm.value.document_date && invoiceForm.value.payment_terms; else placeholderDocumentDate" [minDate]="invoiceForm.value.document_date" [defaultDate]="invoiceForm.value.expiration_date" [displayMonths]="1"
                         [isInvalid]="fieldHasError('expiration_date')" (onSelect)="invoiceForm.patchValue({expiration_date: $event})"></app-datepickr>
          <ng-template #placeholderDocumentDate>
            <input type="date" readonly class="form-control" />
          </ng-template>
          <div class="invalid-feedback d-block" *ngIf="fieldHasError('expiration_date')">{{ "ERRORS.FIELD_IS_REQUIRED" | translate }}</div>
        </div>
        <div class="form-group col-lg-4">
          <label>{{ 'YEAR_OF_ISSUE_FOR_CREDIT_NOTE' | translate }}</label>
          <input type="text" class="form-control" [value]="filterYear" readonly>
        </div>
        <div class="form-group col-lg-4">
          <label>{{ 'CUSTOMER' | translate }}<sup class="text-danger">*</sup></label>
          <input type="text" class="form-control" [value]="creditNote.client.business_name" readonly>
        </div>
        <div class="form-group col-lg-4">
          <label>{{ 'ORDER_NUMBER' | translate }}<sup class="text-danger">*</sup></label>
          <input type="text" class="form-control" formControlName="invoice_order_number" readonly />
        </div>
      </div>
    </div>


    <!-- righe fattura -->
    <div class="card" *ngIf="invoiceForm && rows.controls.length" [formGroup]="invoiceForm">
      <div class="card-header">
        <h2 class="card-title">{{ 'CREDIT_NOTE_ROWS' | translate }}</h2>
        <div class="text-right">
          <button class="btn btn-outline-success btn-sm" type="button" (click)="addRow(); _invoiceService.openLastRow();">{{ 'ADD_ROW' | translate }}</button>
          <button class="btn btn-outline-danger btn-sm ml-1" *ngIf="rowsToManipulate.length > 0" type="button" (click)="removeRows();">{{ 'REMOVE_ROWS' | translate }}</button>
          <button class="btn btn-outline-warning btn-sm ml-1" *ngIf="rowsToManipulate.length < rows.value.length && rows.controls.length > 1" type="button" (click)="selectAllToDelete();">{{ 'SELECT_ALL_TO_DELETE' | translate }}</button>
          <button class="btn btn-outline-warning btn-sm ml-1" *ngIf="rowsToManipulate.length == rows.value.length" type="button" (click)="rowsToManipulate = []">{{ 'DESELECT_ALL_TO_DELETE' | translate }}</button>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-12 px-0" id="invoice-rows">
          <ng-container *ngFor="let rowForm of rows.controls; let i = index; let l = last; let f = first">
            <app-credit-note-row [showCheckbox]="rows.value.length > 1" [checked]="rowsToManipulate.includes(rowForm.value.id)"
                                 [showErrors]="this.showErrors" [rowForm]="rowForm" [index]="i" [lists]="_invoiceService.lists.value"
                                 (calculateTotalAmount)="calculateTotalAmount()"
                                 (toggleSelectRow)="toggleSelectRow($event)"
                                 [classes]="{ 'border-bottom': !l, 'd-none': rowForm.value.has_parent, 'bg-readonly': rowsToManipulate.includes(rowForm.value.analytics_id) }"
            >
            </app-credit-note-row>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- documenti fattura -->
    <app-invoice-file-attachments [invoiceForm]="invoiceForm" [existingAttachments]="creditNote?.attachments || []" (changeAttachmentsList)="attachments_list = $event"></app-invoice-file-attachments>
    <!-- footer -->
    <div class="px-2 pb-6" *ngIf="invoiceForm && invoiceForm.value.total_amount > 0">
      <div class="font-weight-bold font-medium-4 mb-2">{{ "TOTAL" | translate }} {{ invoiceForm.value.total_amount | currency: 'EUR' }}</div>
        <button *ngIf="rows.controls.length > 0" type="submit" class="btn btn-primary" (click)="handlerAction()" [disabled]="!rows.length && !clickedOnSave">{{ "SAVE" | translate }}</button>
    </div>
  </div>
</div>